<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row justify-end items-center mb-3">
 

    <button nz-button nzType="primary" [routerLink]="['/rule-engine/create']">Create Rule</button>
  
  
</div>
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <h1 class="headeradminui-text">Manage Rules</h1>
  </div>
  <div class="flex items-center gap-2">
    <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
      <input nz-input [(ngModel)]="searchInput" placeholder="Search by internal name" />
    </nz-input-group>
    <button nz-button nzType="default" (click)="clearFilters()">Clear filter</button>
  </div>
  
</div>

<!-- <div class="table-container"> -->
  <nz-table #basicTable [nzData]="data" [nzScroll]="{ y: '500px' }" [nzShowPagination]="true" nzFrontPagination="false" [nzTotal]="totalRecords" [nzPageSize]="pageSize" [nzBordered]="true" [nzShowSizeChanger]="true" [nzPageSizeOptions]="pageSizeOptions" [nzPageIndex]="page" nzTableLayout="fixed" (nzPageIndexChange)="nzPageIndexChange($event)" (nzPageSizeChange)="nzPageSizeChange($event)">
    <thead>
      <tr>
        <th>Internal Name</th>
        <th>
          Type
          <nz-filter-trigger [nzActive]="typeFilters.length>0" [nzDropdownMenu]="typeMenu">
            <span nz-icon nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Active
          <nz-switch [ngModel]="activeFilter" (ngModelChange)="onActiveToggle($event)" [nzCheckedChildren]="'true'" [nzUnCheckedChildren]="'false'" style="margin-left: 8px;"></nz-switch>
        </th>
        <th>
          Priority
          <nz-switch [ngModel]="priorityAsc" (ngModelChange)="onPriorityToggle($event)" [nzCheckedChildren]="'ASC'" [nzUnCheckedChildren]="'DESC'" style="margin-left: 8px;"></nz-switch>
        </th>
        <th>Outcome</th>
        <th nzWidth="10%">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of basicTable.data">
        <td>{{ row.name }}</td>
        <td>{{ row.type }}</td>
        <td>{{ row.active }}</td>
        <td>{{ row.priority }}</td>
        <td>
          <div>type: {{ row.event.type }}</div>
          <div>
            params:
            <ng-container *ngFor="let p of row.event.params; index as i">
              <nz-tag [nzColor]="'blue'">{{ p }}</nz-tag>
            </ng-container>
          </div>
        </td>
        <td>
          <button nz-button nzType="default" nzSize="small" nzShape="round" [routerLink]="['/rule-engine/create', row.id]" class="flex flex-row items-center gap-1" nz-tooltip="Edit Rule">
            <span nz-icon nzType="eye" nzTheme="outline"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
<!-- </div> -->

<ng-template #suffixButton>
  <button nz-button nzType="primary" nzSize="small" nzSearch (click)="page=1; fetch()">Search</button>
  </ng-template>



  <nz-dropdown-menu #typeMenu="nzDropdownMenu">
    <div class="bg-white shadow-lg rounded-md  p-3">
      <!-- Header -->
      <div class="mb-2 flex items-center justify-between">
        <span class="font-semibold text-gray-700">Filter by Type</span>
      </div>
      <nz-divider class="my-2"></nz-divider>
  
      <!-- Scrollable checkbox list -->
      <div class="pr-1">
        <nz-checkbox-wrapper (nzOnChange)="onTypeTempChange($event)">
          <div *ngFor="let opt of typeOptions" class="py-1">
            <label nz-checkbox [nzValue]="opt.value" [ngModel]="typeFilters.includes(opt.value)">
              <span class="text-sm text-gray-700 whitespace-nowrap">{{ opt.label }}</span>
            </label>
          </div>
        </nz-checkbox-wrapper>

      </div>
  
      <nz-divider class="my-2"></nz-divider>
  
      <!-- Footer buttons -->
      <div class="flex justify-end gap-2">
        <button nz-button nzType="default" (click)="resetTypeFilter()">Reset</button>
        <button nz-button nzType="primary" (click)="fetch()">Ok</button>
      </div>
    </div>
  </nz-dropdown-menu>
  
  


 
